export interface ReviewerConfig {
  apiHost: string;
  associatedDomain: string;
  cognitoClientId: string;
  cognitoUserPoolId: string;
}

export const reviewerConfigs: Record<string, ReviewerConfig> = {
  'google.reviewer@votes.now': {
    apiHost: 'dev.votes.now',
    associatedDomain: 'groundforce.dev.votes.now',
    cognitoClientId: '5gp8j7u1m15o2fkd1gc0i9m17q',
    cognitoUserPoolId: 'eu-west-2_hVIxMUD5S',
  },
  'apple.reviewer@votes.now': {
    apiHost: 'dev.votes.now',
    associatedDomain: 'groundforce.dev.votes.now',
    cognitoClientId: '5gp8j7u1m15o2fkd1gc0i9m17q',
    cognitoUserPoolId: 'eu-west-2_hVIxMUD5S',
  },
};

export function getReviewerConfig(username: string): ReviewerConfig | null {
  return reviewerConfigs[username] || null;
}

export function isReviewer(username: string): boolean {
  return username in reviewerConfigs;
}
